import React, { useState } from "react"
import moment from "moment"
import ReactTable from "react-table"
import { useQuery } from "@apollo/react-hooks"
import { withRouter } from "react-router"
import { Badge, Card, Button, CardBody } from "reactstrap"
import { Spinner } from "components/spinner"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { announcementTypes, findTypeValueByKey } from "utils/types"
import AnnouncementListOpertionCl from "./AnnouncementListOpertionCl"

import {
  GET_ANNOUNCEMENT_LIST,
  GET_TABLE_FIELDS,
  SUM_ANNOUNCEMENT_LIST
} from "../../gql"
import { CustomServerSideReactTableNew } from "../../../../components/utility"

const AnnouncementListCl = (props) => {
  useBread({ to: props.match.url, name: "公告清單" }, true)

  const columnDefs = [{ title: "關鍵字", name: "keyword", type: "input" }]

  const fieldsDefinitions = () => {
    return [
      {
        Header: "發佈日期",
        style: columStyle,
        accessor: "startTime",
        filterable: false,
        Cell: ({ row }) => moment(row.startTime).format("YYYY-MM-DD a h:mm")
      },
      {
        Header: "標題",
        style: columStyle,
        accessor: "title",
        filterable: false
      },
      {
        Header: "類型",
        style: columStyle,
        accessor: "type",
        filterable: false,
        Cell: ({ row }) => (
          <Badge
            color={row.type === "CONTRACT" ? "warning" : "success"}
            style={{ fontSize: "12px" }}
          >
            {findTypeValueByKey(announcementTypes, row.type)}
          </Badge>
        )
      },
      {
        Header: "詳細資料",
        style: columStyle,
        accessor: "id",
        filterable: false,
        Cell: ({ row }) => (
          <span>
            <Button
              onClick={() => {
                props.history.push(`/announcement/detail/${row.id}`)
              }}
              color="inverse"
              size="sm"
              round="true"
              icon="true"
              style={{ color: "#FFF" }}
            >
              <i className="fas fa-copy" />
            </Button>
          </span>
        )
      }
    ]
  }

  return (
    <CustomServerSideReactTableNew
      columnDefs={columnDefs}
      queryObjectGql={GET_ANNOUNCEMENT_LIST}
      sumTotalQueryObjectGql={SUM_ANNOUNCEMENT_LIST}
      fieldsDefGql={GET_TABLE_FIELDS}
      objectName="公告"
      objectRoute={props.match.url}
      fieldsDef={fieldsDefinitions()}
    />
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(withRouter(AnnouncementListCl))
